import { FleekError } from './FleekError';

type EnsRecord = {
  id?: string;
  status?: string;
};
type EnsRecordInPendingStateErrorOptions = {
  ensRecord: EnsRecord;
};

export class EnsRecordInPendingStateError extends FleekError<EnsRecordInPendingStateErrorOptions> {
  public name = 'EnsRecordInPendingStateError';

  toString = () => {
    return 'ENS Record is in pending state. Please wait and try action again later.';
  };
}
